const routeMain = () => '/artNews';

export default routeMain;
